<div id="kpi-admin" class="kpi-admin">

  <header class="kpi-admin-toolbar" [class.is-editing]="hasPendingChanges">
    <div class="kpi-admin-toolbar-row">
      <div class="kpi-admin-picker"
        [matTooltip]="hasPendingChanges ? 'Save or undo your changes before switching KPI' : ''">
        <span class="kpi-field-label">KPI Account</span>
        <app-searchable-select
          [items]="CurrentKpiList"
          bindLabel="FullName"
          bindValue="index"
          placeholder="Search KPI by MersyID or name"
          loadingText="Loading KPIs..."
          [loading]="isKpiListLoading"
          [clearable]="false"
          [disabled]="isLocked"
          [(ngModel)]="CurrentKpiIndex"
          (selectionChange)="onKpiSelected()">
        </app-searchable-select>
      </div>

      <div class="kpi-admin-actions">
        @if (canEdit) {
          <button type="button" class="btn button-fix button-color-fix-purple"
            [disabled]="!CurrentKpi.KpiDefinitionId"
            (click)="checkKPIAccountHistory()">
            Changelog <mat-icon class="icon-color-fix">history</mat-icon>
          </button>
          <span [matTooltip]="hasPendingChanges ? 'Save or undo your changes first' : 'Add new KPI from selected'">
            <button type="button" class="btn button-fix button-color-fix-purple"
              [disabled]="!CurrentKpi.KpiDefinitionId || isLocked"
              (click)="NewKpi()">
              New KPI <mat-icon class="icon-color-fix">add</mat-icon>
            </button>
          </span>
          @if (hasPendingChanges) {
            <button type="button" class="btn button-fix button-color-fix-grey"
              matTooltip="Discard all unsaved changes"
              [disabled]="isSaving"
              (click)="undoChanges()">
              Undo <mat-icon class="icon-color-fix">undo</mat-icon>
            </button>
            <span [matTooltip]="saveBlockedReason || 'Save changes'">
              <button type="button" class="btn button-fix button-color-fix-orange"
                [disabled]="!!saveBlockedReason || isSaving"
                (click)="save()">
                Save <mat-icon class="icon-color-fix">save</mat-icon>
              </button>
            </span>
          }
        }
      </div>
    </div>

    <div class="kpi-admin-summary">
      <span class="kpi-chip"><span class="kpi-chip-key">Internal code</span>{{ CurrentKpi.KpiDefinitionId || '—' }}</span>
      <span class="kpi-chip"><span class="kpi-chip-key">Group Function</span>{{ CurrentKpi.GroupFunction || '—' }}</span>
      <span class="kpi-chip"><span class="kpi-chip-key">Level</span>{{ CurrentKpi.KpiLevel || '—' }}</span>
      <span class="kpi-chip"><span class="kpi-chip-key">Owner</span>{{ CurrentKpi.KpiOwner || '—' }}</span>
      <span class="kpi-chip"><span class="kpi-chip-key">Unit</span>{{ CurrentKpi.KpiUnit || '—' }}</span>
      @if (CurrentKpi.HideKpi) {
        <span class="kpi-chip is-muted"><mat-icon aria-hidden="true">visibility_off</mat-icon>Hidden</span>
      }
      @if (CurrentKpi.IsVirtual) {
        <span class="kpi-chip is-accent"><mat-icon aria-hidden="true">functions</mat-icon>Virtual</span>
      }
    </div>

    @if (hasPendingChanges) {
      <output class="kpi-warning">You have unsaved changes. Click Save to keep them or Undo to discard them.</output>
    }
  </header>

  <form [formGroup]="KpiForm" class="kpi-admin-form" autocomplete="off">

    <app-collapsible-section heading="KPI Behaviour">
      <div class="kpi-panel">
        <div class="kpi-flags">
          <label class="kpi-flag">
            <input type="checkbox" class="kpi-switch" formControlName="HideKpi" />
            <span class="kpi-flag-text">
              <span class="kpi-flag-title">Hide KPI</span>
              <span class="kpi-flag-hint">KPI Visibility</span>
            </span>
          </label>
          <label class="kpi-flag">
            <input type="checkbox" class="kpi-switch" formControlName="isForecastRequired" />
            <span class="kpi-flag-text">
              <span class="kpi-flag-title">Forecast Required</span>
            </span>
          </label>
          <label class="kpi-flag">
            <input type="checkbox" class="kpi-switch" formControlName="NoOplRequired" />
            <span class="kpi-flag-text">
              <span class="kpi-flag-title">NO OPL Required</span>
            </span>
          </label>
          <label class="kpi-flag">
            <input type="checkbox" class="kpi-switch" formControlName="NoActRequired" />
            <span class="kpi-flag-text">
              <span class="kpi-flag-title">NO ACT Required</span>
            </span>
          </label>
          <label class="kpi-flag">
            <input type="checkbox" class="kpi-switch" formControlName="IsAccumulative" />
            <span class="kpi-flag-text">
              <span class="kpi-flag-title">
                Is Accumulative
                <mat-icon class="kpi-info-icon" aria-hidden="true"
                  matTooltip="When a KPI is considered accumulative, suggested monthly split will be based on the forecast provided during OPL">info</mat-icon>
              </span>
            </span>
          </label>
          <label class="kpi-flag">
            <input type="checkbox" class="kpi-switch" formControlName="NegativeDiffIsGood" />
            <span class="kpi-flag-text">
              <span class="kpi-flag-title">Negative Diff. is good</span>
            </span>
          </label>
          <label class="kpi-flag">
            <input type="checkbox" class="kpi-switch" formControlName="IsVirtual" />
            <span class="kpi-flag-text">
              <span class="kpi-flag-title">Is Virtual</span>
            </span>
          </label>
          @if (isGlobalExcellenceLevel) {
            <label class="kpi-flag">
              <input type="checkbox" class="kpi-switch" formControlName="IsBranchExcellenceRelated" />
              <span class="kpi-flag-text">
                <span class="kpi-flag-title">IsGlobalExcellenceRelated</span>
              </span>
            </label>
          }
          @if (isBranchExcellenceRelated) {
            <label class="kpi-field kpi-flag-field">
              <span class="kpi-field-label">Global Excellence Order</span>
              <input class="kpi-input" formControlName="BranchExcellenceOrder" type="number" />
            </label>
          }
        </div>

        @if (isVirtual) {
          <div class="kpi-virtual" [class.has-error]="calcFormulaError !== 0">
            <label class="kpi-field">
              <span class="kpi-field-label">
                Calculation Formula
                <mat-icon aria-hidden="true"
                  matTooltip="The formula must consist of the identifiers of the two required KPIs, along with the arithmetic operation to be applied between them.">info</mat-icon>
              </span>
              <input class="kpi-input" formControlName="CalculationFormula" type="text"
                [class.is-invalid]="calcFormulaError !== 0"
                placeholder="e.g. 862 / 863"
                (blur)="updateCalcFormulaDescription()" />
            </label>
            <p class="kpi-virtual-preview" aria-live="polite">
              <mat-icon aria-hidden="true">{{ calcFormulaError !== 0 ? 'error_outline' : 'functions' }}</mat-icon>
              <span>{{ calcFormulaDescription || '—' }}</span>
            </p>
          </div>
        }
      </div>
    </app-collapsible-section>

    <app-collapsible-section heading="KPI Definition master data">
      <div class="kpi-panel">
        <h5 class="kpi-group-title">Identification</h5>
        <div class="kpi-grid">
          <label class="kpi-field">
            <span class="kpi-field-label">Account (MersyID)</span>
            <input class="kpi-input" formControlName="MersyId" readonly type="text" />
          </label>
          <label class="kpi-field kpi-span-2">
            <span class="kpi-field-label">Kpi Name</span>
            <input class="kpi-input" formControlName="KpiName" type="text" />
          </label>
          <label class="kpi-field">
            <span class="kpi-field-label">KPI Plan</span>
            <input class="kpi-input" formControlName="KpiPlan" type="text" />
          </label>
          <label class="kpi-field">
            <span class="kpi-field-label">Kpi Level</span>
            <select class="kpi-input" formControlName="KpiLevel">
              @for (item of KpiLevels; track item) {
                <option [value]="item.Value">{{ item.Value }}</option>
              }
            </select>
          </label>
          <label class="kpi-field">
            <span class="kpi-field-label">KPI Owner (Group Function)</span>
            <select class="kpi-input" formControlName="KpiOwner">
              @for (item of KpiOwners; track item) {
                <option [value]="item.Value">{{ item.Value }}</option>
              }
            </select>
          </label>
        </div>

        <h5 class="kpi-group-title">Reporting</h5>
        <div class="kpi-grid">
          <label class="kpi-field">
            <span class="kpi-field-label">KPI Unit</span>
            <select class="kpi-input" formControlName="KpiUnit">
              @for (item of KpiUnits; track item) {
                <option [value]="item.Value">{{ item.Value }}</option>
              }
            </select>
          </label>
          <label class="kpi-field">
            <span class="kpi-field-label">FormatFactor</span>
            <select class="kpi-input" formControlName="FormatFactor">
              @for (item of FormatFactors; track item) {
                <option [value]="item.Value">{{ item.Value }}</option>
              }
            </select>
          </label>
          <label class="kpi-field">
            <span class="kpi-field-label">ReportingType</span>
            <select class="kpi-input" formControlName="ReportingType">
              @for (item of ReportingTypes; track item) {
                <option [value]="item.Value">{{ item.Value }}</option>
              }
            </select>
          </label>
          <label class="kpi-field">
            <span class="kpi-field-label">ReportingAggregate</span>
            <input class="kpi-input" formControlName="ReportingAggregate" type="text" />
          </label>
          <label class="kpi-field">
            <span class="kpi-field-label">AvailabilityTime</span>
            <input class="kpi-input" formControlName="AvailabilityTime" type="text" />
          </label>
        </div>

        <h5 class="kpi-group-title">Documentation</h5>
        <div class="kpi-grid kpi-grid-wide">
          <label class="kpi-field kpi-span-full">
            <span class="kpi-field-label">KPI Description</span>
            <input class="kpi-input" formControlName="KpiDescription" type="text" />
          </label>
          <label class="kpi-field">
            <span class="kpi-field-label">KPI Formula</span>
            <input class="kpi-input" formControlName="KpiFormula" type="text" />
          </label>
          <label class="kpi-field">
            <span class="kpi-field-label">KPI Definition Technical</span>
            <input class="kpi-input" formControlName="KpiDefinitionTechnical" type="text" />
          </label>
          <label class="kpi-field">
            <span class="kpi-field-label">KPI Definition Content</span>
            <input class="kpi-input" formControlName="KpiDefinitionContent" type="text" />
          </label>
        </div>
      </div>
    </app-collapsible-section>

    <app-collapsible-section heading="Group Function (Node)" [count]="CurrentKpi.GroupFunctionSubItems.length">
      @if (canEdit) {
        <span section-actions [matTooltip]="hasPendingChanges ? 'Save or undo your changes first' : 'Add new Group Function'">
          <button type="button" class="btn button-color-fix-purple kpi-section-button"
            [disabled]="!CurrentKpi.KpiDefinitionId || isLocked"
            (click)="alterGF()">
            Add <mat-icon class="icon-color-fix">add</mat-icon>
          </button>
        </span>
      }
      <div class="kpi-panel">
        <ul class="kpi-gf-list" aria-label="Group Functions">
          @for (groupFunction of CurrentKpi.GroupFunctionSubItems; track groupFunction) {
            <li class="kpi-gf-chip" [class.is-active]="groupFunction === CurrentKpi.GroupFunction">
              <button type="button" class="kpi-gf-select"
                [attr.aria-pressed]="groupFunction === CurrentKpi.GroupFunction"
                [disabled]="isLocked && groupFunction !== CurrentKpi.GroupFunction"
                (click)="selectGroupFunction(groupFunction)">
                {{ groupFunction }}
              </button>
              @if (canEdit && groupFunction === CurrentKpi.GroupFunction) {
                <button type="button" class="kpi-gf-delete"
                  [attr.aria-label]="'Delete Group Function ' + groupFunction"
                  [matTooltip]="hasPendingChanges ? 'Save or undo your changes first' : 'Delete Group Function'"
                  [disabled]="isLocked"
                  (click)="deleteGF()">
                  <mat-icon aria-hidden="true">delete</mat-icon>
                </button>
              }
            </li>
          } @empty {
            <li class="kpi-section-hint">{{ isKpiListLoading ? 'Loading KPIs...' : 'No Group Functions assigned.' }}</li>
          }
        </ul>
        <p class="kpi-section-hint">The definition and dimensions shown belong to the selected Group Function.</p>
      </div>
    </app-collapsible-section>

    <app-collapsible-section heading="KPI Dimension configuration" [count]="activeDimensionSlots.length">
      <div class="kpi-panel">
        @if (hasPendingChanges && dimensionError) {
          <p class="kpi-warning" role="alert">{{ dimensionError }}</p>
        }
        <div class="kpi-dimensions">
          @for (slot of dimensionSlots; track slot.key) {
            <kpi-dimension-card
              [heading]="slot.heading"
              [caption]="slot.caption"
              [enabled]="slot.enabled"
              [order]="slot.order"
              [positions]="dimensionPositions"
              [dimensionName]="slot.dimensionName"
              [dimensionNames]="dimensionNameOptions[slot.key]"
              [items]="slot.items"
              [editable]="canEdit && !isSaving"
              [control]="dimensionControl(slot.key)"
              (enabledChange)="onDimensionToggle(slot, $event)"
              (orderChange)="onDimensionOrderChange(slot, $event)"
              (dimensionNameChange)="onDimensionNameChange(slot, $event)">
            </kpi-dimension-card>
          }
        </div>
      </div>
    </app-collapsible-section>

    @if (!isProductionEnvironment) {
      <app-collapsible-section heading="DEV Tools" [expanded]="false">
        <div class="kpi-panel kpi-danger-zone">
          <p class="kpi-section-hint">Only available outside production.</p>
          <div class="kpi-danger-actions">
            <button type="button" class="btn button-fix button-color-fix-grey"
              [disabled]="!CurrentKpi.KpiDefinitionId || isLocked"
              (click)="cleanKpi()">
              Clean KPI <mat-icon class="icon-color-fix">cleaning_services</mat-icon>
            </button>
            <button type="button" class="btn button-fix button-color-fix-red"
              [disabled]="!CurrentKpi.KpiDefinitionId || isLocked"
              (click)="deleteKpiCascade()">
              Delete <mat-icon class="icon-color-fix">delete_forever</mat-icon>
            </button>
          </div>
        </div>
      </app-collapsible-section>
    }
  </form>
</div>
